// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_63a3","cardRow":"e353","item":"_93a1","image":"_793c","imageSquare":"f882","textDiv":"_9abb"};